<script setup lang="ts">
import { isArray } from "lodash-es";
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { actionSourceKey } from "@/components/action/injectKeys";
import SelectStickyType from "@/components/sticky/SelectStickyType/SelectStickyType.vue";
import { dropdownKey } from "@/components/ui/DropdownMenu/injectKeys";
import type { StickyType } from "@/model/stickyType";
import { useBoardStore } from "@/store/board";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);
const dropdown = injectStrict(dropdownKey);
const actionSource = injectStrict(actionSourceKey);

// Show creatable sticky types, but disable types from other boards.
// Changing to a type from another board causes ALM sync issues for linked stickies,
// so we disable all non-origin types for consistency.
const stickyTypes = computed(() => useBoardStore().creatableStickyTypes);

const boardType = computed(() => useBoardStore().currentBoard().type);

const isNonOriginType = (type: StickyType) => type.origin !== boardType.value;

const onChange = (targetType: StickyType | readonly StickyType[]) => {
  const type = isArray(targetType) ? targetType[0] : targetType;
  cardActions.setType(actionSource, card, type);

  dropdown.close();
};
</script>

<template>
  <SelectStickyType
    :sticky-types
    :is-item-disabled="isNonOriginType"
    :disabled-message="$t('stickyTypeChange.nonOriginTypeDisabled')"
    @update:model-value="onChange"
  />
</template>
